import React from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import CCrud from "components/Molecules/Crud";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import { useThemePalette } from "common/hooks/theme_palette";

function CartLogsTemplate({
  data,
  count,
  details,
  paginationPage,
  handlePageChange,
  rowData,
  breadcrumbs,
  filterList,
  actionsList,
  headerChildren,
  modalComponents,
  selectedRow,
  filterObj,
  setFilterObj,
}) {
  const { t } = useTranslation();
  const { orange } = useThemePalette();

  const columnData = [
    { accessor: "id", Header: t("cart_logs.cart_id") },
    { accessor: "amount", Header: t("cart_logs.amount"), sort: true },
    { accessor: "amount_with_vat", Header: t("cart_logs.amount_with_vat") },
    { accessor: "delivery_fees", Header: t("cart_logs.delivery_fees") },
    { accessor: "state", Header: t("cart_logs.state") },
    { accessor: "date", Header: t("cart_logs.date"), sort: true },
    { accessor: "Actions", Header: t("cart_logs.actions") },
  ];

  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("cart_logs.title"),
            columns: columnData,
            isSearch: false,
            searchInputPlaceholder: "",
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList,
            details,
          }}
          modalComponents={modalComponents}
          detailsTemplateData={{
            deleteBtn: false,
            editBtn: false,
            pageTitle: t("cart_logs.cart_log_details"),
            data: {
              list: [
                {
                  head: t("cart_logs.cart_information"),
                  details: [
                    { label: t("cart_logs.cart_id"), name: details?.cart?.id },
                    {
                      label: t("cart_logs.date"),
                      name: dayjs(details?.cart?.created_at).format(
                        "DD-MM-YYYY, hh a"
                      ),
                    },
                    {
                      label: t("cart_logs.amount"),
                      name: `${details?.cart?.amount} ${
                        details?.currency?.name || ""
                      }`,
                    },
                    {
                      label: t("cart_logs.amount_with_vat"),
                      name: `${details?.cart?.amount_with_vat} ${
                        details?.currency?.name || ""
                      }`,
                    },
                    {
                      label: t("cart_logs.delivery_fees"),
                      name: `${details?.cart?.delivery_fees} ${
                        details?.currency?.name || ""
                      }`,
                    },
                    { label: t("cart_logs.weight"), name: `${details?.cart?.weight}` },
                    { label: t("cart_logs.state"), name: details?.cart?.state },
                  ],
                },
              ],
            },
          }}
        />
      </Box>
    </>
  );
}

export default CartLogsTemplate;
